/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import { BaSeButton, BaSeStepper } from '@base/react';
import FormAddress from './form-address';
import { FormContext } from '../../hook/form-context';
import ListClasses from './list-classes';
import FormPersonalData from '../form-personal-data/form-personal-data';

function StepperActions({ imgEmpretecSelected }) {
  const [currentStep, setCurrentStep] = React.useState(1);

  const {
    classes,
    pageIndex,
    totalPages,
    totalItems,
    handleSelectClass,
    handlePageChange,
    selectedIdClass,
    selectedUfOption,
    setNextScreen,
    handleChangePersonalData,
    personalData,
    showButtonStartInterview,
    handleCreateInterview,
    empretecId,
  } = React.useContext(FormContext);

  const isStepValid = React.useCallback(() => {
    if (currentStep === 1) return !!selectedUfOption && !!selectedIdClass;
    if (currentStep === 3) return !!showButtonStartInterview;
    return false;
  }, [
    currentStep,
    selectedIdClass,
    showButtonStartInterview,
    selectedUfOption,
  ]);

  const isDisabled = !isStepValid();

  const mapNameButton = {
    1: 'Fazer minha entrevista',
    2: 'Iniciar minha autoavaliação',
    3: 'Fazer minha entrevista',
    4: 'Desejo participar',
  };

  return (
    <div>
      <BaSeStepper
        activeColor="#FFC700"
        completedColor="#69D169"
        uncompletedColor="#B6BFC8"
        currentStep={currentStep}
        onStepChange={setCurrentStep}
        orientation="horizontal"
        steps={[
          {
            content: () => (
              <>
                {imgEmpretecSelected && (
                  // eslint-disable-next-line jsx-a11y/img-redundant-alt
                  <img
                    style={{ margin: '0 auto 20px auto' }}
                    src={imgEmpretecSelected.mobile}
                    alt={`Image empretec selected`}
                  />
                )}
                <FormAddress />
                <ListClasses
                  classes={classes}
                  handlePageChange={handlePageChange}
                  pageIndex={pageIndex}
                  handleSelectClass={handleSelectClass}
                  selectedIdClass={selectedIdClass}
                  selectedUfOption={selectedUfOption}
                  totalItems={totalItems}
                  totalPages={totalPages}
                />
              </>
            ),
            title: ['Estado e', 'Cidade'],
            isCompleted: !!selectedUfOption,
          },
          {
            content: () => (
              <>
                {imgEmpretecSelected && (
                  // eslint-disable-next-line jsx-a11y/img-redundant-alt
                  <img
                    style={{ margin: '0 auto 20px auto' }}
                    src={imgEmpretecSelected.mobile}
                    alt={`Image empretec selected`}
                  />
                )}
                <FormAddress />
                <ListClasses
                  classes={classes}
                  handlePageChange={handlePageChange}
                  pageIndex={pageIndex}
                  handleSelectClass={handleSelectClass}
                  selectedIdClass={selectedIdClass}
                  selectedUfOption={selectedUfOption}
                  totalItems={totalItems}
                  totalPages={totalPages}
                />
              </>
            ),
            title: 'Valor e período',
            isCompleted: !!selectedIdClass,
          },
          {
            content: () => (
              <div>
                {imgEmpretecSelected && (
                  // eslint-disable-next-line jsx-a11y/img-redundant-alt
                  <img
                    style={{ margin: '0 auto 20px auto' }}
                    src={imgEmpretecSelected.mobile}
                    alt={`Image empretec selected`}
                  />
                )}
                <FormPersonalData
                  handleChangePersonalData={handleChangePersonalData}
                  personalData={personalData}
                />
              </div>
            ),
            title: 'Dados pessoais',
          },
        ]}
      />

      <div style={{ display: 'grid', gap: 16, marginTop: '20px' }}>
        <BaSeButton
          borderRadius="max"
          buttonType="submit"
          overrideColors={{
            backgroundColor: '#fff',
            foreground: '#0000C9',
          }}
          rightIcon={currentStep === 3 ? '' : '"system/arrow-right-line"'}
          onClick={() => {
            if (!!selectedUfOption && !!selectedIdClass) {
              setCurrentStep(3);
            } else {
              setCurrentStep((prev) => prev + 1);
            }

            if (currentStep === 3) {
              handleCreateInterview();
            }
          }}
          loadingText="Carregando…"
          size="big"
          width="100%"
          isDisabled={isDisabled}
          type="primary"
          value={currentStep === 3 ? mapNameButton[empretecId] : 'Próximo'}
        />
        <BaSeButton
          borderRadius="max"
          buttonType="submit"
          overrideColors={{
            foreground: '#fff',
            borderColor: '#fff',
          }}
          rightIcon="system/arrow-left-line"
          onClick={() => {
            if (currentStep === 1) {
              setNextScreen(false);
              return;
            }

            setCurrentStep((prev) => prev - 1);
          }}
          loadingText="Carregando…"
          size="big"
          width="100%"
          type="tertiary"
          value="Voltar"
        />
      </div>
    </div>
  );
}

export default StepperActions;
